const _inFlightValidationKeys = new Set();
const _completedValidationKeys = new Set();
const _savedTokenKeys = new Set();

/**
 * Attempts to start provider validation for the given key.
 *
 * @param {string} key - Validation key.
 * @returns {boolean}
 */
export function tryStartProviderValidation(key) {
    if (!key) {
        return false;
    }

    if (_inFlightValidationKeys.has(key) || _completedValidationKeys.has(key)) {
        return false;
    }

    _inFlightValidationKeys.add(key);

    return true;
}

/**
 * Marks provider validation as successful.
 *
 * @param {string} key - Validation key.
 * @returns {void}
 */
export function markProviderValidationSuccess(key) {
    if (!key) {
        return;
    }

    _inFlightValidationKeys.delete(key);
    _completedValidationKeys.add(key);
}

/**
 * Marks provider validation as failed.
 *
 * @param {string} key - Validation key.
 * @returns {void}
 */
export function markProviderValidationFailed(key) {
    if (!key) {
        return;
    }

    _inFlightValidationKeys.delete(key);
}

/**
 * Resets validation keys for a provider prefix.
 *
 * @param {string} providerPrefix - Key prefix (for example, 'onedrive:').
 * @returns {void}
 */
export function resetProviderValidation(providerPrefix) {
    for (const key of _inFlightValidationKeys) {
        if (key.startsWith(providerPrefix)) {
            _inFlightValidationKeys.delete(key);
        }
    }

    for (const key of _completedValidationKeys) {
        if (key.startsWith(providerPrefix)) {
            _completedValidationKeys.delete(key);
        }
    }
}

/**
 * Attempts to mark provider token as already saved.
 *
 * @param {string} key - Save token key.
 * @returns {boolean}
 */
export function tryMarkProviderTokenSaved(key) {
    if (!key) {
        return false;
    }

    if (_savedTokenKeys.has(key)) {
        return false;
    }

    _savedTokenKeys.add(key);

    return true;
}

/**
 * Resets saved-token keys for a provider prefix.
 *
 * @param {string} providerPrefix - Key prefix (for example, 'onedrive:').
 * @returns {void}
 */
export function resetProviderSavedTokens(providerPrefix) {
    for (const key of _savedTokenKeys) {
        if (key.startsWith(providerPrefix)) {
            _savedTokenKeys.delete(key);
        }
    }
}
